import { ArrowBackIcon, Box, Button, Logo, Typography, useMediaQuery, useTheme } from '@hermes/web-components'
import { useLocale } from '@hooks/useLocale'
import Link from 'next/link'
import React from 'react'
import {
  AbsoluteBoxCenterContent,
  Divider,
  NavBarBodyContainer,
  NavBarContainer,
  NavBarContentContainer
} from './FlowHeader.styles'

interface Props {
  title?: string
  onClick?: () => void
  children?: React.ReactNode
}

export const FlowHeader = ({ title, onClick, children }: Props) => {
  const theme = useTheme()
  const locale = useLocale()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  return (
    <NavBarContainer>
      <NavBarBodyContainer maxWidth="xl">
        {isDesktop && (
          <Link aria-label="home" href={`/${locale}`} prefetch={true}>
            <Logo width={143} height={44} />
          </Link>
        )}
        <NavBarContentContainer>
          {onClick && (
            <Button onClick={onClick} variant="ghost">
              <ArrowBackIcon width="20px" />
            </Button>
          )}
          <AbsoluteBoxCenterContent>
            {title && (
              <Typography fontSize="16px" lineHeight="20px" fontWeight="500">
                {title}
              </Typography>
            )}
          </AbsoluteBoxCenterContent>
        </NavBarContentContainer>
        {isDesktop && <Box width="143px" />}
      </NavBarBodyContainer>
      <Divider />
      {children}
    </NavBarContainer>
  )
}
